module.exports = __webpack_public_path__ + "img/add-payment.db959c1b.svg";